import { Pipe, PipeTransform } from '@angular/core';
import { LabelI18nService } from '../_services/label-i18n.service';

@Pipe({
  name: 'localizedLabel',
  pure: false
})
export class LocalizedLabelPipe implements PipeTransform {
  constructor(private labelI18n: LabelI18nService) {}

  transform(fallback: string | undefined, kind: 'indicator' | 'projectType' | 'synthese', code?: string): string | undefined {
    if (kind === 'indicator') return this.labelI18n.indicatorName(code, fallback);
    if (kind === 'synthese') return this.labelI18n.syntheseLabel(fallback);
    return this.labelI18n.projectTypeName(code, fallback);
  }
}
